import * as React from "react";

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m113.3 47.41 183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9.719-9.625-9.125-9.938-24.38-.719-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78.719-33.91 9.561-9.19 24.771-8.87 33.871.72z"
  }));
}

const ForwardRef = React.forwardRef(ChevronRightIcon);
export default ForwardRef;